import axios from 'axios'
import router from '../router'
import store from '../store/store'
import {Message} from 'element-ui';
import qs from 'qs'


axios.defaults.baseURL = getBaseUrl();
function getBaseUrl() {
  var curWwwPath = window.document.location.href;

  var protocol = window.document.location.protocol;
  //console.log("protocol:" + protocol);
  var hostname = window.document.location.hostname;
  //console.log("hostname:" + hostname);
  var host = window.document.location.host;
  //console.log("host:" + host);
  var port = window.document.location.port;
  //console.log("port:" + port);
  //判断是访问客户端还是后台
  if (curWwwPath.indexOf("8083") >= 0) {
    // curWwwPath = "http://192.168.101.33:9390/";
    curWwwPath = protocol + "//" + hostname + ":9595/";
    // curWwwPath ="https://qiujing.easy.echosite.cn";
  } else {
    curWwwPath = protocol + "//" + hostname + "/";
    // curWwwPath = "https://qiujing.easy.echosite.cn";
  }

  //console.log("baseURL:" + curWwwPath);
  return curWwwPath;
}

function getImageUrl() {
  var curWwwPath = window.document.location.href;
  var protocol = window.document.location.protocol;
  var hostname = window.document.location.hostname;
  //判断是访问客户端还是后台
  if (curWwwPath.indexOf("8083") >= 0) {
    curWwwPath = protocol + "//" + hostname + ":9595/";

  } else {
    curWwwPath = protocol + "//" + hostname + "/";
  }
  return curWwwPath;
}

axios.defaults.timeout = 10000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.interceptors.request.use(

  config => {

    if (store.state.staff) {
      config.headers["Authorization"] = store.state.staff.token;
    }
    if (config.method === 'post' || config.method === 'patch') {
      config.data = qs.stringify(config.data);
    }
    return config;
  },
  error => {
    console.log("err request");
    return Promise.reject(error);
  }
);
var isOutLogin = 0;
axios.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    if (error.response) {
      console.log(error);
      switch (error.response.status) {
        case 500:
          // Message.error(error.response.data.message);
          break;
        case 401:
          isOutLogin++;
          if (isOutLogin == 1) {
            Message.warning("登录超时!");
          }
          window.sessionStorage.clear();
          router.options.routes.splice(2, router.options.routes.length - 2);
          router.push({path: '/cal'});
          break;
        case 504:
          window.sessionStorage.clear();
          router.options.routes.splice(2, router.options.routes.length - 2);
          router.push({path: '/cal'});
          break;
        case  200:
          isOutLogin = 0;
          break;
      }
    }
    if (error.toString().indexOf('timeout') >= 0) {
      Message.warning("请求超时！");
    }
    return Promise.reject(error);
  }
);

export const queryInsurerOption = params => {
  return axios.get("/client/prom/insurer/option", {params: params})
};

export const queryPlanNameOption = params => {
  return axios.get("/client/prom/planName/option", {params: params})
};

export const queryPlanYearOption = params => {
  return axios.get("/client/prom/planYear/option", {params: params})
};

export const queryPrepayYearOption = params => {
  return axios.get("/client/prom/prepayYear/option", {params: params})
};

export const calClientProm = params => {
  return axios.get("/client/prom/cal", {params: params})
};

export const queryChiNameById = params => {
  return axios.get("/client/prom/chiName", {params: params})
};



// WEBPACK FOOTER //
// ./src/api/api.js